const state= {
    equipments:{
        items:[],
        total:0,
        pages: {
            limit: 100,
            page: 1,
            totalPage : 1,
            filter: {}
          },
    },
    equipmentLoading: {
        listing: false,
        category:false,
        import: false
    },
};

const getters = {
    equipments : (state) => state.equipments
};

const actions = {
    async getEquipments({commit}, params){
        return new Promise (( resolve, reject ) => {
            commit( 'setLoading', {key: "listing",val : true} );
            global.axios.get(`api/s-contracts/${params.filter.contract_id.value}/equipment`,{params:params})
                .then(response => {
                    response.data.data.pages = params
                    commit( 'setLoading', {key: "listing",val : false} );
                    commit( 'setItems', response.data.data );
                    resolve( response );
                })
                .catch(error => reject( error ));
        });
    },
    async getVendorLinkingEquipments({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/vendor-linkings/equipment`,{params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async saveVendorLinkingEquipments({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios(`api/vendor-linkings/equipment`, {
                method: "PUT",
                data: params,
                headers: {
                    Accept: "application/json",
                }
            })
                .then(response => {
                    resolve(response);
                })
                .catch(error => reject(error));
        });
    },
};

const mutations = {
    setItems (state,equipments) {
        equipments.pages.totalPage = Math.ceil(equipments.total / equipments.pages.limit );
        state.equipments.items = equipments.items;
        state.equipments.total = equipments.total;
        state.equipments.pages = equipments.pages;
    },
    setLoading (state,params) {
        if(params.key === "listing"){
            state.equipmentLoading.listing = params.val;
        }
        if(params.key === "category"){
            state.equipmentLoading.category = params.val;
        }
        if(params.key === "import"){
            state.equipmentLoading.import = params.val;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
